import React, { use } from 'react'
import JavascriptUtilsTooling from '../../../../tooling/javascriptUtilsTooling';
import Constants from '../../../../definitions/constants';

class SelectWithTextBoxInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchedValue: "",
      minLength: 1,
      manuallyDisplayOptions: false,
      maxOptionsBeforeScroll: 6,
    }
  }

  componentDidMount() {
    if(this.props.maxOptionsBeforeScroll){
      this.setState({ maxOptionsBeforeScroll: this.props.maxOptionsBeforeScroll })
    }
    this.optionsWrapper.style.maxHeight = (this.state.maxOptionsBeforeScroll * 26) + "px";
  }

  handleOnChange = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    this.setState({
      searchedValue: value
    })
  };

  handleClickInput = (event) => {
    this.optionsWrapper.style.minWidth = this.inputText.getBoundingClientRect().width + "px";
    this.optionsWrapper.style.top = (this.inputText.getBoundingClientRect().top + this.inputText.getBoundingClientRect().height + 2) + "px";
    this.optionsWrapper.style.left = (this.inputText.getBoundingClientRect().left) + "px";
    this.handleOnChange(event);
  }

  handleOnClick = (event) => {
    let value = event.currentTarget.dataset.value;
    let label = event.currentTarget.dataset.label;
    if(this.props.onClickOption) {
      this.props.onClickOption({
        currentTarget: {
          dataset: {
            path: this.props["data-path"],
            selectSearchBox: true,
          },
          value: value
        }
      });
    }
    this.setState({
      searchedValue: "",
      manuallyDisplayOptions: false,
    });
  };

  handleOnInputKeyDown = (event) => {
    if(this.props.doesTriggerOnKeyEnter && event.key == "Enter") {
      let value = this.state.searchedValue;
      if(this.props.onClickOption) {
        this.props.onClickOption({
          currentTarget: {
            dataset: {
              path: this.props["data-path"],
            },
            value: value
          }
        });
      }
      this.setState({ searchedValue: "", manuallyDisplayOptions: false });
    }
  };

  handleClearButton = (event) => {
    this.setState({
      searchedValue: "",
    });
    if(this.props.onClearTextCallback) {
      this.props.onClearTextCallback({
        currentTarget: {
          dataset: {
            path : this.props["data-path"],
          },
          value: ""
        }
      });
    }
  }

  handleManuallySeeOptionsButton = (event) => {
    this.inputText.focus();
    this.optionsWrapper.style.minWidth = this.inputText.getBoundingClientRect().width + "px";
    this.optionsWrapper.style.top = (this.inputText.getBoundingClientRect().top + this.inputText.getBoundingClientRect().height + 2) + "px";
    this.optionsWrapper.style.left = (this.inputText.getBoundingClientRect().left) + "px";
    this.setState({ manuallyDisplayOptions: true });
  }

  handleOnInputFocusLost = (event) => {
    this.setState({ manuallyDisplayOptions: false });
  }

  render() {
    const {
      id,
      className,
      values, // Array: Current selected values, used for filtering options
      options, // Array: Format {value, label} with the options
      onClickOption,
      addSelectLocale,
      hideClearButton,
      doesTriggerOnKeyEnter, // Boolean: If true, the onClickOption will be triggered when pressing enter
      maxOptionsBeforeScroll, // Number: Maximum number of options before the scroll appears (this is a close aproximation, it may vary depending on font size and browser)
      onClearTextCallback, // Function: Optional callback for when the clear text button ("X") is clicked
      disabled,
    } = this.props; 

    const dataPath = this.props["data-path"];

    let filteredOptions = JavascriptUtilsTooling.deepCopy(options);

    let valuesMap = {};
    if(values && options) {
      for(var i=0; i < values.length; i++) {
        valuesMap[values[i]] = true;
      }
    }
    
    //Filter options by values selected
    if(values && options) {
      filteredOptions = options.filter(option => !(option.value in valuesMap));
    }

    let currentValue = options.find(option => option.value == values) ? options.find(option => option.value == values).label : "";
    
    if(options && this.state.searchedValue && this.state.searchedValue.length>=this.state.minLength) {
      filteredOptions = filteredOptions.filter(dataItem => dataItem.label.toUpperCase().indexOf(this.state.searchedValue.toUpperCase()) > -1);
    }
    
    let noOptionsLeft = filteredOptions.length == 0 ? true : false;

    return(
      <div className={"custom-input text-select-input matter-textfield-outlined" + (className ? " " + className : "")}>
        <input 
          id={id}
          placeholder={addSelectLocale}
          value={currentValue || this.state.searchedValue}
          type={Constants.interface.inputs.type.TEXT}                
          onChange={this.handleOnChange}
          onClick={this.handleClickInput}
          onKeyDown={this.handleOnInputKeyDown}          
          autoComplete={"off"}
          data-path={dataPath}
          ref={(input) => { this.inputText = input; }}
          onBlur={this.handleOnInputFocusLost}
          disabled={disabled || currentValue}
        />
        {(!hideClearButton && (this.state.searchedValue.length>0 || currentValue)) && <i className="clear_text_button fas fa-times-circle" onClick={this.handleClearButton}/>}
        {((!currentValue && this.state.searchedValue.length==0) && !noOptionsLeft) && 
          <i 
            className="display_options_button fas fa-caret-down"
            onClick={this.handleManuallySeeOptionsButton}
            data-value=""
            data-label=""
          />
        }
        <div
          className={"options_wrapper" +
            ((!noOptionsLeft && ((this.state.searchedValue.length>=this.state.minLength && filteredOptions.length>0) ||
              this.state.manuallyDisplayOptions)) ? "" : " hidden_options")}
          ref={(input) => { this.optionsWrapper = input; }}
        > 
          {(!noOptionsLeft && (this.state.searchedValue.length>=this.state.minLength || this.state.manuallyDisplayOptions)) && (
            <div className="options_wrapper_inner" ref={(input) => { this.optionsWrapper = input; }}>
              {filteredOptions && filteredOptions.map((item,i) => {
                return (
                  <div 
                    onMouseDown={this.handleOnClick}
                    className="fetched_option" 
                    key={i}
                    data-value={item.value}
                    data-label={item.label}
                    title={item.label}
                  >
                    {item.label}
                  </div>
                );
              })}
            </div>
          )}      
        </div>
      </div>
    ) 
  }
}

export default SelectWithTextBoxInput;


// WEBPACK FOOTER //
// ./source/client/components/common/inputs/selectWithTextBoxInput.jsx